import { useMemo } from 'react';

import { OFFERS_CATEGORY } from '@/common/constants';

import useStocks from '../stocks/useStocks';

const useFlags = (flags, stocks) => {
  const { getStocks } = useStocks(stocks);
  /**
   * Recover the quantity available or with a delay of 12 to 24 hours
   * @type {object}
   */

  const getFlags = useMemo(() => {
    if (
      flags.some((flag) => flag.slug === OFFERS_CATEGORY.CLEARANCE) &&
      getStocks.available === 0 &&
      getStocks.delayed === 0 &&
      getStocks.notAvailable === 0
    ) {
      return flags.filter((flag) => flag.slug !== OFFERS_CATEGORY.CLEARANCE);
    }

    return flags;
  }, [flags, getStocks]);

  return { getFlags };
};

export default useFlags;
